import { render, staticRenderFns } from "./AdminSegment.vue?vue&type=template&id=9a671e50&"
import script from "./AdminSegment.vue?vue&type=script&lang=js&"
export * from "./AdminSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports